"use client";

import BlurredPlaceholder from "@/app/(components)/generics/BlurredPlaceholder/BlurredPlaceholder";
import ProgressBar, {
  ProgressBarVariant,
} from "@/app/(components)/generics/ProgressBar/ProgressBar";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { UserClientAvatar } from "@/app/types/client-avatar/UserClientAvatar";
import { UStyles } from "@/app/utils/UStyles";
import styles from "../../AvatarDetail.module.css";
import cardStyles from "../AvatarDetailCard/AvatarDetailCard.module.css";

type Props = {
  avatar: UserClientAvatar;
  isPlaceholder: boolean;
  showFitSummary?: boolean;
  params: { lang: string };
};

export default function AvatarScoresGrid(props: Props) {
  const T = useT();
  const { avatar, isPlaceholder, showFitSummary } = props;
  return (
    <>
      <div className={styles.scoresGrid}>
        <div className={styles.scoreItem}>
          <div className={styles.scoreItemTop}>
            <p className={styles.scoreTitle}>{T(TKey.CLIENT_AVATAR_DETAIL_FIT_TITLE)}</p>
            {isPlaceholder ? (
              <BlurredPlaceholder rows={[{ cells: [{ width: "50px" }] }]} />
            ) : (
              <div className={styles.scoreValueContainer}>
                <p className={UStyles.classNames(styles.scoreValue, styles.textGreen)}>
                  {avatar.scoreFit ?? 0}
                </p>
                <span className={styles.scoreMax}>/100</span>
              </div>
            )}
          </div>
          <ProgressBar
            value={avatar.scoreFit ?? 0}
            variant={ProgressBarVariant.GREEN}
            isPlaceholder={isPlaceholder}
          />
        </div>

        <div className={styles.scoreItem}>
          <div className={styles.scoreItemTop}>
            <p className={styles.scoreTitle}>{T(TKey.CLIENT_AVATAR_DETAIL_SCORE_CONFIDENCE)}</p>
            {isPlaceholder ? (
              <BlurredPlaceholder rows={[{ cells: [{ width: "50px" }] }]} />
            ) : (
              <div className={styles.scoreValueContainer}>
                <p className={UStyles.classNames(styles.scoreValue, styles.textBlue)}>
                  {avatar.scoreConfidence ?? 0}
                </p>
                <span className={styles.scoreMax}>/100</span>
              </div>
            )}
          </div>
          <ProgressBar
            value={avatar.scoreConfidence ?? 0}
            variant={ProgressBarVariant.BLUE}
            isPlaceholder={isPlaceholder}
          />
        </div>

        <div className={styles.scoreItem}>
          <div className={styles.scoreItemTop}>
            <p className={styles.scoreTitle}>{T(TKey.CLIENT_AVATAR_DETAIL_SCORE_PAIN)}</p>
            {isPlaceholder ? (
              <BlurredPlaceholder rows={[{ cells: [{ width: "50px" }] }]} />
            ) : (
              <div className={styles.scoreValueContainer}>
                <p className={UStyles.classNames(styles.scoreValue, styles.textRed)}>
                  {avatar.scorePain ?? 0}
                </p>
                <span className={styles.scoreMax}>/100</span>
              </div>
            )}
          </div>
          <ProgressBar
            value={avatar.scorePain ?? 0}
            variant={ProgressBarVariant.RED}
            isPlaceholder={isPlaceholder}
          />
        </div>
      </div>

      {showFitSummary && !isPlaceholder && avatar.fitSummary && (
        <p className={cardStyles.textBody}>{avatar.fitSummary}</p>
      )}
    </>
  );
}
